import { createSlice } from '@reduxjs/toolkit';

const clientSlice = createSlice({
  name: 'client',
  initialState: {
    rows: [],
    typeRows:[],
    locations: [],
    mappingRows: [],
    workingHours: [],
    // Per-client reference caches, keyed by client id, populated once on
    // dashboard load (and on demand as a fallback). Let the report filter and
    // the Add Activity / Add Leave dialogs read these instead of re-fetching on
    // every dropdown change.
    typesByClient: {},
    membersByClient: {},
    // Members reporting to a manager, keyed by manager_id (the by-manager endpoint's key).
    membersByManager: {}
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
    replaceTypeData(state, action) {
      state.typeRows = action.payload;
    },
    // Cache the activity types for a single client. payload: { clientId, data }
    cacheTypesForClient(state, action) {
      state.typesByClient[String(action.payload.clientId)] = action.payload.data;
    },
    // Cache the members for a single client. payload: { clientId, data }
    cacheMembersForClient(state, action) {
      state.membersByClient[String(action.payload.clientId)] = action.payload.data;
    },
    // Cache the members reporting to a single manager. payload: { managerId, data }
    cacheMembersForManager(state, action) {
      state.membersByManager[String(action.payload.managerId)] = action.payload.data;
    },
    replaceMappingData(state, action) {
      state.mappingRows = action.payload;
    },
    replaceLocationData(state, action) {
      state.locations = action.payload;
    },
    replaceWorkingHours(state, action) {
      state.workingHours = action.payload;
    },
  },
});

export const clientActions = clientSlice.actions;
export default clientSlice;